import React, { Component } from 'react';

import { Link } from 'react-router';
import { dateHelpers } from '../../../../../helpers';
import DeleteModal from '../../../../common/elements/DeleteModal';

class JobItemSaved extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: null
        }
    }

    handleDelete = () => {
        this.props.removeJobFromFavourites(this.props.job.id, this.props.index)
        this.setState({ modal: null })
    }

    render() {
        const { job, index, permissions, addJobToFavourites, removeJobFromFavourites } = this.props;

        const isExclusive = job.exclusive,
            isFavourite = job.favourite,
            jobType = job.premium_type,
            salary = job.salary && (job.salary.length > 35 || job.salary === 'N/A' ? null : job.salary),
            title = job.title,
            secondaryTitle = job.secondary_title,
            isPremium = job.premium_type === 1,
            isFeatured = job.premium_type === 2,
            isViewed = job.viewed,
            applied = (Object.hasOwnProperty(job.job_application) && Object.keys(job.job_application).length) ? job.job_application.complete : false,
            appliedDate = Object.hasOwnProperty(job.job_application) ? dateHelpers.dateConverter(job.job_application.created_at) : null,
            companyLogoExists = job && job.company_logo !== null,
            logoUrl = companyLogoExists && job.company_logo.replace(/ /g, "%20");

        return (
            <div className="job-item job-item--saved" key={index}>
                <div className="job-item__details">
                    <div className="row">
                        <div className="col-xs-12 col-sm-7 col-md-9">
                            <h4 className="h4 job-item__title" dangerouslySetInnerHTML={{ __html: title }} />
                        </div>
                        <div className="hidden-xs col-sm-5 col-md-3 details--right">
                            {
                                isFavourite &&

                                <button className="btn btn-small-flat-emphasis btn-basic" onClick={() => this.setState({ modal: 'yes' })}>
                                    <span className="label">Remove from favourites</span>
                                    <span className="icon"><i
                                        className="fa fa-times" /></span>
                                </button>

                            }
                        </div>
                        <div className="col-xs-12">

                            {
                                appliedDate !== null &&
                                <div className="job-item__status job-status--applied">
                                    <span>
                                        {
                                            !applied ?
                                                <div>
                                                    <p className="p-tag">
                                                        {`It looks like you may have applied on ${appliedDate}. `}
                                                        <Link to={`/my-jobs/my-applications?id=${job.id}`}>
                                                            Click here</Link> to confirm.
                                                    </p>
                                                </div>
                                                :
                                                <div>
                                                    <p className="p-tag">Applied: {appliedDate}</p>
                                                </div>
                                        }
                                    </span>
                                </div>
                            }
                        </div>
                        <div className="col-xs-12 col-sm-8 col-md-9">
                            <ul className="details--grey">
                                <li>Industry: {job.industry.name}</li>
                                <li>Salary: <span dangerouslySetInnerHTML={{ __html: salary }} /></li>
                                <li>Location: {job.region.name}</li>
                            </ul>
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-3">
                            <ul className="details--grey details--right">
                                <li>Job #{job.id}</li>
                                <li>Closing date: {dateHelpers.dateConverter(job.end_date)}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="job-item__buttons">
                    <div className="row">
                        <div className="col-xs-12">
                            <ul className="buttons-right buttons-right--responsive">
                                {
                                    isViewed ?
                                        (
                                            <li>
                                                <Link className="theme-button job-viewed"
                                                    to={`/jobs/${job.id}`}>
                                                    <span>View again</span>
                                                </Link>
                                            </li>
                                        )
                                        :
                                        (
                                            <li>
                                                <Link className="theme-button"
                                                    to={`/jobs/${job.id}`}>
                                                    <span>View job</span>
                                                </Link>
                                            </li>
                                        )
                                }
                                <li className="visible-xs-block">
                                    <button className="theme-button secondary" onClick={() => this.setState({ modal: 'yes' })}>
                                        <span className="label">Remove from favourites</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div>
                    {this.state.modal && <DeleteModal header='Are you sure?' message="This can't be undone." onClose={() => this.setState({ modal: null })} onDelete={this.handleDelete} />}
                </div>
                <hr />
            </div>

        );
    };
}

export default JobItemSaved;



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobItemSaved.js